/** sessionStorage flag for iframe embed mode — opt-in only. */
export const EMBED_SESSION_KEY = 'itms_embed';

/** Survives AuthGuard / signin-callback races when query params are lost. */
export const EMBED_RETURN_URL_KEY = 'itms_embed_return_url';

export function isEmbedSession(): boolean {
    try {
        return sessionStorage.getItem(EMBED_SESSION_KEY) === '1';
    } catch {
        return false;
    }
}

export function markEmbedSession(): void {
    try {
        sessionStorage.setItem(EMBED_SESSION_KEY, '1');
    } catch {
        // ignore
    }
}

export function getEmbedReturnUrl(): string | null {
    try {
        const value = sessionStorage.getItem(EMBED_RETURN_URL_KEY);
        return value && value !== '/' ? value : null;
    } catch {
        return null;
    }
}

export function setEmbedReturnUrl(url: string): void {
    try {
        if (url && url !== '/') {
            sessionStorage.setItem(EMBED_RETURN_URL_KEY, url);
        }
    } catch {
        // ignore
    }
}

export function clearEmbedReturnUrl(): void {
    try {
        sessionStorage.removeItem(EMBED_RETURN_URL_KEY);
    } catch {
        // ignore
    }
}

/** Prefer stored embed returnUrl, then fallback, never empty for navigation. */
export function resolveEmbedReturnUrl(fallback?: string | null): string {
    const stored = getEmbedReturnUrl();
    if (stored) {
        return stored;
    }
    const fb = (fallback ?? '').trim();
    if (fb && fb !== '/') {
        return fb;
    }
    return '/';
}
